module.exports = __webpack_public_path__ + "img/open1.b498c241.png";